import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Popover } from "antd";
import Logo from "../../../assets/images/PoweredNew.png";
import userProfile from "../../../assets/images/userProfile.svg";
import profileIcon from "../../../assets/images/profile-icon.svg";
import changepasswordIcon from "../../../assets/images/change-password-icon.svg";
import logoutIcon from "../../../assets/images/logout-icon.svg";
import { useStore } from "../../../store";
import { setActivePartner } from "../../../store/actions";
import "./index.scss";

function MicroSites() {
  const navigate = useNavigate();
  const location = useLocation();
  const { dispatch, activePartner } = useStore();
  const [isShowProfile, setIsShowProfile] = useState(false);
  const [logoFailed, setLogoFailed] = useState(false);

  const showProfile = () => {
    setIsShowProfile(!isShowProfile);
  };

  const LogoutHandler = () => {
    sessionStorage.clear();
    window.location.reload();
  };

  const clearActivePartner = () => {
    dispatch(setActivePartner({ id: null, mediaLink: null }));
    sessionStorage.removeItem("partnerMediaLink");
    sessionStorage.removeItem("partnerAppLogo"); // legacy key cleanup
  };

  // Hydrate store from sessionStorage after refresh
  useEffect(() => {
    const partnerId = sessionStorage.getItem("partnerId");
    const partnerMediaLink =
      sessionStorage.getItem("partnerMediaLink") ||
      sessionStorage.getItem("partnerAppLogo");
    if (partnerId && !activePartner?.id) {
      dispatch(
        setActivePartner({
          id: partnerId,
          mediaLink: partnerMediaLink || null,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Home Partners list always shows default Expo365 logo
  useEffect(() => {
    const path = location.pathname;
    if (path === "/admin" || path === "/admin/") {
      clearActivePartner();
      setLogoFailed(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    setLogoFailed(false);
  }, [activePartner?.mediaLink]);

  const partnerLogo =
    !logoFailed && activePartner?.mediaLink ? activePartner.mediaLink : null;
  const logoSrc = partnerLogo || Logo;

  return (
    <div className="headerBannerRow">
      <div className="headerBannerCol">
        <div className="header-logo">
          <img
            style={{ cursor: "pointer" }}
            src={logoSrc}
            alt=""
            onError={() => setLogoFailed(true)}
            onClick={() =>
              window.open("https://www.connectsu.co.uk/", "_blank")
            }
          />
        </div>

        <div className="org-container">
          <div className="org-text">
            <label className="user-name"> User name</label>
            <label className="admin-name">Super Admin</label>
          </div>
          <Popover
            content={
              <div className="popover-content">
                <div className="dropdown-details">
                  <div
                    className="popover-single-content"
                    onClick={() => {
                      setIsShowProfile(false);
                      navigate("/admin");
                    }}
                  >
                    <img src={profileIcon} alt="" />
                    <h3>Home</h3>
                  </div>
                  <div
                    className="popover-single-content"
                    onClick={() => {
                      setIsShowProfile(false);
                      navigate("/change-password");
                    }}
                  >
                    <img src={changepasswordIcon} alt="" />
                    <h3>Change Password</h3>
                  </div>
                  <div
                    className="popover-single-content"
                    onClick={LogoutHandler}
                  >
                    <img src={logoutIcon} alt="" />
                    <h3>Logout</h3>
                  </div>
                </div>
              </div>
            }
            trigger="click"
            open={isShowProfile}
            onOpenChange={showProfile}
            placement="bottomRight"
          >
            <img
              style={{ cursor: "pointer", margin: "10px" }}
              onClick={() => showProfile()}
              src={userProfile}
              alt=""
            />
          </Popover>
        </div>
      </div>
    </div>
  );
}
export default MicroSites;
